<template>
  <stats-card v-loading="loading"
              :sub-title="$t('teamsStatsCard.title')"
              :title="totalTeams"
              type="primary"
              icon="tim-icons icon-molecule-40">
    <div slot="footer">
      <i class="tim-icons icon-bus-front-12"></i>{{$t('teamsStatsCard.lockedVehiclesLabel', {count:
      lockedVehiclesCount}) }}
    </div>
  </stats-card>
</template>
<script>
  import StatsCard from 'src/components/Cards/StatsCard';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'inspector-teams-stats-card',
    components: {
      StatsCard,
    },
    methods: {
      ...mapActions(['LoadInspectorTeams', 'LoadPtLocks']),
    },
    computed: {
      ...mapState({
        teamsLoading: state => state.inspector_teams.loading,
        teamsData: state => state.inspector_teams.data,
        locksLoading: state => state.pt_locks.loading,
        locksData: state => state.pt_locks.locks,
      }),
      loading: function () {
        return this.teamsLoading || this.locksLoading
      },
      totalTeams: function () {
        let data = this.teamsData
        return "" + data.length
      },
      lockedVehiclesCount: function () {
        let data = this.locksData
        return data ? "" + data.length : "0"
      }
    },
    mounted() {
      this.LoadInspectorTeams();
      this.LoadPtLocks();
    },
  };
</script>
